import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DiscountService {

  constructor(private http: HttpClient) { }

  getDiscounts() {
    return this.http.get<any[]>(`${environment.paramUrlBase}/api/discounts/discounts-slider`);
  }
}
